<template>
  <article>
    <h2>A little bit about myself</h2>
    <p>
      My name is Liam, I'm a {{ new Date().getFullYear()-2002 }}-year-old
      French-British binational developer currently living in France.
    </p>
    <p>
      My current interests revolve around Computer Science, Literature,
      Philosophy, Culture, Art and Music. I consider myself a lifelong learner
      and I revel in studying and exploring new ideas and subjects.
    </p>
    <p>
      Throughout the years I have acquired experience with
      <span
        ref="python-text"
        @mouseenter="reactiveHighlight($event, 'python')"
        @mouseleave="reactiveHighlightRemove($event, 'python')"
      >Python (>=3.x)</span>,
      <span
        ref="php-text"
        @mouseenter="reactiveHighlight($event, 'php')"
        @mouseleave="reactiveHighlightRemove($event, 'php')"
      >PHP (>=7.0)</span>,
      <span
        ref="sql-text"
        @mouseenter="reactiveHighlight($event, 'sql')"
        @mouseleave="reactiveHighlightRemove($event, 'sql')"
      >SQL, PL/SQL</span>,
      <span
        ref="javascript-text"
        @mouseenter="reactiveHighlight($event, 'javascript')"
        @mouseleave="reactiveHighlightRemove($event, 'javascript')"
        >HTML, CSS, JavaScript</span>,
      <span
        ref="vue-text"
        @mouseenter="reactiveHighlight($event, 'vue')"
        @mouseleave="reactiveHighlightRemove($event, 'vue')"
      >Vue.js</span> and
      <span
        ref="react-text"
        @mouseenter="reactiveHighlight($event, 'react')"
        @mouseleave="reactiveHighlightRemove($event, 'react')"
      >React</span>
      .
    </p>
    <p>
      I have also worked as a video editor and graphic designer and I am
      proficient with the Adobe Suite, especially
      <span
        ref="photoshop-text"
        @mouseenter="reactiveHighlight($event, 'photoshop')"
        @mouseleave="reactiveHighlightRemove($event, 'photoshop')"
      >Photoshop</span>
      and
      <span
        ref="aftereffects-text"
        @mouseenter="reactiveHighlight($event, 'aftereffects')"
        @mouseleave="reactiveHighlightRemove($event, 'aftereffects')"
      >After Effects</span>.
    </p>
    <ul>
      <li>
        <div ref="python" class="img python"
          @mouseenter="reactiveHighlight($event, 'python')"
          @mouseleave="reactiveHighlightRemove($event, 'python')"
        ></div>
      </li>
      <li>
        <div ref="php" class="img php"
          @mouseenter="reactiveHighlight($event, 'php')"
          @mouseleave="reactiveHighlightRemove($event, 'php')"
        ></div>
      </li>
      <li>
        <div ref="sql" class="img sql"
          @mouseenter="reactiveHighlight($event, 'sql')"
          @mouseleave="reactiveHighlightRemove($event, 'sql')"
        ></div>
      </li>
      <li>
        <div ref="javascript" class="img javascript"
          @mouseenter="reactiveHighlight($event, 'javascript')"
          @mouseleave="reactiveHighlightRemove($event, 'javascript')"
        ></div>
      </li>
      <li>
        <div ref="vue" class="img vue"
          @mouseenter="reactiveHighlight($event, 'vue')"
          @mouseleave="reactiveHighlightRemove($event, 'vue')"
        ></div>
      </li>
      <li>
        <div ref="react" class="img react"
          @mouseenter="reactiveHighlight($event, 'react')"
          @mouseleave="reactiveHighlightRemove($event, 'react')"
        ></div>
      </li>
      <li>
        <div ref="photoshop" class="img photoshop"
          @mouseenter="reactiveHighlight($event, 'photoshop')"
          @mouseleave="reactiveHighlightRemove($event, 'photoshop')"
        ></div>
      </li>
      <li>
        <div ref="aftereffects" class="img aftereffects"
          @mouseenter="reactiveHighlight($event, 'aftereffects')"
          @mouseleave="reactiveHighlightRemove($event, 'aftereffects')"
        ></div>
      </li>
    </ul>
    <div class="resume">
      <a :href="pdf" download>
        <button>Resume</button>
      </a>
    </div>
    <div class="isdat">
      <a :href="isdat" download>
        <button>Lettre ISDAT</button>
      </a>
    </div>

  </article>
</template>

<script>
import { TimelineLite } from "gsap/dist/gsap";
export default {
  name: "Description",
  data() {
    return {
      pdf: require("../assets/RESUME.pdf"),
      isdat: require("../assets/lettre-isdat.pdf")
    };
  },
  methods: {
    reactiveHighlight(event, block) {
      this.$refs[block].classList.add("mask");
      const tl = new TimelineLite();
      tl.to(this.$refs[block + "-text"], {
        backgroundColor: "#1a1a1a",
        color: "white",
      });
    },
    reactiveHighlightRemove(event, block) {
      this.$refs[block].classList.remove("mask");
      const tl = new TimelineLite();
      tl.to(this.$refs[block + "-text"], {
        backgroundColor: "#141414",
        color: "#8d8d8d"
      });
    },
  },
};
</script>

<style scoped>
p {
  font-size: clamp(16px, 1.2vw, 1.2vw);
  line-height: 2;
  text-align: justify;
  color: #9d9d9d;
}

h2 {
  font-size: clamp(24px, 3vw, 3vw);
  font-weight: 300;
  margin: 0;
}
ul {
  margin-top: clamp(3em, 4vw, 4vw);
  margin-bottom: clamp(3em, 4vw, 4vw);
  list-style-type: none;
  display: flex;
  justify-content: space-around;
  padding: 0;
}


.resume {
  margin: auto;
  display: flex;
  justify-content: center;
}

.isdat {
  opacity: 0;
  display: none;
}

button {
  height: 30px;
  border: none;
  font-size: 18px;
  font-weight: 900;
  background-color: white;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

button:hover {
  background-color: #59ff9c;
}

.img {
  height: fit-content;
  width: fit-content;
  display: block;
}

.img::after {
  content: "";
  width: inherit;
  height: inherit;
  position: absolute;
  background: inherit;
  background-position: center center;
  z-index: -1;

  /* initial state */
  filter: blur(0px) saturate(0);
  transition: filter 0.3s ease-out;
  -webkit-transition: filter 0.3s ease-out;
  -moz-transition: filter 0.3s ease-out;
  -o-transition: filter 0.3s ease-out;
}

.python {

  height: 30px;
  width: 30px;
  background: url("../assets/icons/python.svg");
  background-size: contain;
}

.javascript {
  height: 30px;
  width: 30px;
  background: url("../assets/icons/js.svg");
  background-size: contain;
}

.php {
  height: 30px;
  width: 55px;
  background: url("../assets/icons/php.svg");
  background-size: contain;
}

.photoshop {
  height: 35px;
  width: 35px;
  background: url("../assets/icons/photoshop.svg");
  background-size: contain;
}

.aftereffects {
  height: 35px;
  width: 35px;
  background: url("../assets/icons/after-effects.svg");
  background-size: contain;
}

.sql {
  height: 40px;
  width: 40px;
  background: url("../assets/icons/sql.svg");
  background-size: contain;
}

.vue {
  height: 30px;
  width: 35px;
  background: url("../assets/icons/vue.svg");
  background-size: contain;
}

.react {
  height: 35px;
  width: 30px;
  background: url("../assets/icons/react.svg");
  background-size: contain;
}

.mask::after {
  filter: blur(10px) saturate(3);
}

span {
  background-color: #141414;
  margin: 0.3em;
  padding: 0.3em 0.7em;
  color: #8d8d8d;
}
</style>
